export default __webpack_public_path__ + "static/media/SIC-logo-power-by.a876b4b7.png";